import { Divider, Group } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkPeriodStore } from '../../../store/work-period-store/work-period-store';
import { baseWhite, secondaryBase } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { Radio } from '../../../ui-library/radio/radio';
import { Text } from '../../../ui-library/typography/typography';
import { Metric, WorkPeriod } from '../work-periods.type';

type Props = {
  title: string;
  selectedWorkPeriod?: WorkPeriod;
  additionalControls?: ReactNode;
  hideRadio?: boolean;
  floraButton?: ReactNode;
  onExport?: () => void;
};

export const WorkPeriodChartHeader = ({
  title,
  selectedWorkPeriod,
  onExport,
  hideRadio = false,
  additionalControls,
  floraButton,
}: Props) => {
  const i18n = useTranslation();
  const { selectedMetric, setSelectedMetric } = useWorkPeriodStore();
  return (
    <Group justify="space-between">
      <Text size="large" weight="bold">
        {`${title} ${selectedWorkPeriod ? `| ${selectedWorkPeriod.name}` : ''}`}
      </Text>
      <Group>
        {!hideRadio && (
          <Group>
            <Radio
              value="tasks"
              label={i18n.t('common.work_units')}
              checked={selectedMetric === Metric.Tasks}
              onChange={() => setSelectedMetric(Metric.Tasks)}
              color={secondaryBase}
            />
            <Radio
              value="points"
              label={i18n.t('common.estimation')}
              checked={selectedMetric === Metric.Points}
              onChange={() => setSelectedMetric(Metric.Points)}
              color={secondaryBase}
            />
          </Group>
        )}
        {additionalControls}
        {additionalControls && <Divider orientation="vertical" />}
        <Button
          radius="xl"
          size="xs"
          variant="secondary"
          leftSection={<Icon name="download" variant="filled" color={baseWhite} size={16} />}
          onClick={onExport}
        >
          Export
        </Button>
        {floraButton}
      </Group>
    </Group>
  );
};
